const translations = {
    en: {
        customize: {
            service_card: {
                status: {
                    available: "BOOK NOW",
                    booked: "BOOKED!",
                    wait_response: "AWAITING RESPONSE",
                },
                free: "FREE"
            }
        }
    },
    de: {
        customize: {
            service_card: {
                status: {
                    available: "JETZT BUCHEN",
                    booked: "GEBUCHT!",
                    wait_response: "IN ERWARTUNG IHRER BESTÄTIGUNG",
                },
                free: "FREI"
            }
        }
    },
    es: {
        customize: {
            service_card: {
                status: {
                    available: "RESERVE AHORA",
                    booked: "RESERVADO!",
                    wait_response: "ESPERE UN MOMENTO",
                },
                free: "GRATIS"
            }
        }
    },
    fr: {
        customize: {
            service_card: {
                status: {
                    available: "RÉSERVEZ MAINTENANT",
                    booked: "RÉSERVÉ!",
                    wait_response: "En attente de confirmation",
                },
                free: "GRATUIT"
            }
        }
    },
    it: {
        customize: {
            service_card: {
                status: {
                    available: "PRENOTA ORA",
                    booked: "PRENOTATO!",
                    wait_response: "IN ATTESA DI CONFERMA"
                },
                free: "GRATIS"
            }
        }
    }
};

export default translations;


// WEBPACK FOOTER //
// ./translations/customize/ServiceCard.js